import { Routes } from '@angular/router';
import { AdminLayout } from './layouts/admin-layout/admin-layout';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { authGuard } from './core/guards/auth.guard';
import { admissionStepGuard } from './core/guards/admission-step.guard';
import { AccessDenied } from '@features/error-pages/access-denied/access-denied';
import { NotFound } from '@features/error-pages/not-found/not-found';
import { ServerError } from '@features/error-pages/server-error/server-error';
import { SessionTimeout } from '@features/error-pages/session-timeout/session-timeout';
import { LinkNotPublished } from '@shared/components/link-not-published/link-not-published';
import { domainResolver } from '@core/domain.resolver';
import { publishLinkGuard } from '@core/guards/publish-link.guard';
import { paymentAccessGuard } from './core/guards/payment-access.guard';

export const routes: Routes = [

  // {
  //   path: '',
  //   component: AdminLayout,
  //   canActivate: [authGuard],
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: 'student-form',
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: 'student-form',
  //       loadComponent: () =>
  //         import('./features/student-form/student-form')
  //           .then(m => m.StudentForm)
  //     }
  //   ]
  // },

  {
    path: '',
    redirectTo: 'admission',
    pathMatch: 'full'
  },
 {
    path: 'admission',
     resolve: { domain: domainResolver },
    loadComponent: () =>
      import('./layouts/admin-layout/admin-layout').then(m => m.AdminLayout),
    children: [
      { path: '', redirectTo: 'student-form', pathMatch: 'full', title: 'STUDENT ADMISSION FORM',
        data: { breadcrumb: 'STUDENT ADMISSION FORM' } },
      {
        path: 'student-form',title: 'STUDENT ADMISSION FORM',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'STUDENT ADMISSION FORM', admissionStep: 'student-form' },
        loadComponent: () =>
          import('./features/student-form/student-form').then(m => m.StudentForm)
      },
      {
        path: 'schooltransport',
        title: 'REQUEST TRANSPORT FORM',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'REQUEST TRANSPORT FORM', admissionStep: 'schooltransport' },
        loadComponent: () =>
          import('./features/school-transport/school-transport').then(m => m.SchoolTransport)
      },
       {
        path: 'own-transport',
        title: 'OWN TRANSPORT FORM',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'OWN TRANSPORT FORM', admissionStep: 'own-transport' },
        loadComponent: () =>
          import('./features/own-transport/own-transport').then(m => m.OwnTransport)
      },
       {
        path: 'medical',
        title: 'MEDICAL FORM',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'MEDICAL FORM', admissionStep: 'medical' },
        loadComponent: () =>
          import('./features/medical-form/medical-form').then(m => m.MedicalForm)
      },
       {
        path: 'age',title: 'AGE UNDERTAKING FORM',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'AGE UNDERTAKING FORM', admissionStep: 'age' },
        loadComponent: () =>
          import('./features/age-undertaking/age-undertaking').then(m => m.AgeUndertaking)
      },
       {
        path: 'noc',title: 'NO OBJECTION CERTIFICATE FOR USING STUDENT PHOTOGRAPH, VIDEO & NAME',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'NOC', admissionStep: 'noc' },
        loadComponent: () =>
          import('./features/no-objection-certificate/no-objection-certificate').then(m => m.NoObjectionCertificate)
      },
       {
        path: 'msg',
        title: 'Student Admission',
        canActivate: [publishLinkGuard],
        data: { breadcrumb: 'MSG' },

        loadComponent: () =>
          import('./shared/components/sucess-message/sucess-message').then(m => m.SucessMessage)
      },
      {
        path: 'fee',
        title: 'Fee Details',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'Fee Details', admissionStep: 'fee' },

        loadComponent: () =>
          import('./features/fee-structure/fee-structure').then(m => m.FeeStructure)
      },
      {
        path: 'paymentlink',
        title: 'Admission Payment',
        canActivate: [publishLinkGuard, paymentAccessGuard],
        data: { breadcrumb: 'Admission Payment' },
        loadComponent: () =>
          import('./features/admission-payment/admission-payment').then(m => m.AdmissionPayment)
      },
      {
        path: 'paymentlink/:reportparams',
        title: 'Admission Payment',
        canActivate: [publishLinkGuard, paymentAccessGuard],
        data: { breadcrumb: 'Admission Payment' },
        loadComponent: () =>
          import('./features/admission-payment/admission-payment').then(m => m.AdmissionPayment)
      },
      {
  path: 'paymentstatus/:orderId', //
  title: 'Payment Status',
  canActivate: [publishLinkGuard, paymentAccessGuard],
  data: { breadcrumb: 'Payment Status' },
  loadComponent: () =>
    import('./features/payment-status/payment-status')
      .then(m => m.PaymentStatus)
},
      {
  path: 'paymentlink-status/:orderId',
  title: 'Admission Payment Result',
  canActivate: [publishLinkGuard, paymentAccessGuard],
  data: { breadcrumb: 'Admission Payment Result' },
  loadComponent: () =>
    import('./features/admission-payment-result/admission-payment-result')
      .then(m => m.AdmissionPaymentResult)
},
{
        path: 'receipt/:reportparams',
        title: 'Admission Invoice',
        canActivate: [publishLinkGuard, paymentAccessGuard],
        data: { breadcrumb: 'Admission Invoice' },
        loadComponent: () =>
          import('./features/invoice/invoice').then(m => m.Invoice)
      },
 {
        path: 'config-ui',
        title: 'STUDENT FORM PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'STUDENT FORM PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/config-ui-page/config-ui-page').then(m => m.ConfigUiPage)
      },
 {
        path: 'school-transport-config',
        title: 'SCHOOL TRANSPORT PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'SCHOOL TRANSPORT PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/school-transport-config-page/school-transport-config-page').then(
            m => m.SchoolTransportConfigPage,
          )
      },
 {
        path: 'own-transport-config',
        title: 'OWN TRANSPORT PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'OWN TRANSPORT PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/own-transport-config-page/own-transport-config-page').then(
            m => m.OwnTransportConfigPage,
          )
      },
 {
        path: 'medical-config',
        title: 'MEDICAL PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'MEDICAL PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/medical-config-page/medical-config-page').then(
            m => m.MedicalConfigPage,
          )
      },
{
        path: 'age-config',
        title: 'AGE UNDERTAKING PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'AGE UNDERTAKING PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/age-config-page/age-config-page').then(m => m.AgeConfigPage)
      },
 {
        path: 'noc-config',
        title: 'NOC PREVIEW',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'NOC PREVIEW', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/noc-config-page/noc-config-page').then(m => m.NocConfigPage)
      },
      {
        path: 'menu',
        title: 'Preview Menu',
        canActivate: [publishLinkGuard, admissionStepGuard],
        data: { breadcrumb: 'Preview Menu', admissionStep: 'menu' },
        loadComponent: () =>
          import('./features/menu/menu').then(m => m.Menu)
      },
    ]
  },

  {
    path: 'auth',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login')
            .then(m => m.Login)
      }
    ]
  },
   {
    path: '403',
    component: AccessDenied
  },

  {
    path: '500',
    component: ServerError
  },
  {
    path: 'session-timeout',
    component: SessionTimeout
  },
  {
    path: 'link-not-published',
    component: LinkNotPublished
  },

  {
    path: '**',
    component: NotFound
  }
];
